export type TripGuide = { duration?: string; overview: string; route: string[] };
export type LyricInterlude = { japanese: string; chinese: string; song: string };
export type TripStop = { time: string; endTime?: string; title: string; note: string; icon: string; tag?: string; mapQuery?: string; mascot?: string; guide?: TripGuide; lyric?: LyricInterlude };
export type TripDay = { id: 1 | 2 | 3; date: string; dateLabel: string; weekday: string; theme: string; subtitle: string; accent: string; lyric?: LyricInterlude; stops: TripStop[] };

export const mapUrl = (query: string) => `https://uri.amap.com/search?keyword=${encodeURIComponent(query)}&callnative=1`;

export const trip = {
  title: "重庆 Aqours Trip", dates: "2026.08.22 — 08.24", startDate: "2026-08-22", eventStart: "2026-08-23T12:00:00+08:00",
  event: { name: "Aqours Only", venue: "MODERN SKY LAB 重庆", mall: "重庆大悦城", time: "12:00 — 20:00", route: "渝北广场 → 10号线 → 中央公园西 → 重庆大悦城", mapQuery: "重庆大悦城 MODERN SKY LAB" },
  base: { name: "民宿", location: "渝北广场站附近", mapQuery: "重庆渝北广场地铁站", image: "/images/minsu-living-room.webp" },
  visuals: {
    heroBackground: "/images/aqours-seaside.jpg",
    sunshineLogo: "/images/love-live-sunshine-series.svg",
  },
  mascots: {
    countdown: "/images/chika/countdown-100.jpg",
    day1: "/images/chika/happy.jpg",
    day2: "/images/chika/cheer.jpg",
    day3: "/images/chika/hot.jpg",
    sleepy: "/images/chika/sleepy.jpg",
    friends: "/images/chika/good-friends.jpg",
  },
  lyrics: {
    hero: { japanese: "ステキな旅に出よう", chinese: "去开启一场美好的旅程吧。", song: "HAPPY PARTY TRAIN" },
    footer: { japanese: "ほら次はどこ？　一緒に行こう", chinese: "那么下一站去哪？一起走吧。", song: "Next SPARKLING!!" },
  },
  members: [
    { name: "青空", icon: "✈", from: "南昌", transport: "飞机", arrival: "08:50", destination: "江北机场 T3", detail: "06:55 起飞" },
    { name: "冬叶", icon: "🚆", from: "怀化", transport: "K486", arrival: "09:21", destination: "重庆北站", detail: "K486 · 怀化出发" },
    { name: "寝屋", icon: "🚆", from: "怀化", transport: "K486", arrival: "09:21", destination: "重庆北站", detail: "K486 · 怀化出发" },
    { name: "琪露诺", icon: "🚆", from: "柳州", transport: "火车", arrival: "14:19", destination: "重庆西站", detail: "柳州出发" },
  ],
  tips: {
    general: "重庆的夏天一定很热闹！水、纸巾和充电宝都带上，累了就一起找个凉快的地方休息吧。",
    event: "今天可是 Aqours Only！痛包、吧唧和谷子都确认好了吗？准备完成，就一起出发吧！",
    walk: "穿上最舒服的鞋，慢慢从黄昏走进重庆的夜色。最后一天，也要把每一刻好好记住哦。",
  },
  days: [
    { id: 1, date: "2026-08-22", dateLabel: "08.22", weekday: "周六", theme: "山城初见", subtitle: "四个人到齐，重庆篇正式开始！", accent: "#ff9e3d", stops: [
      { time: "上午", title: "先到民宿", note: "先吃饭、休息，想在附近逛逛也可以。上午就留给大家自由发挥吧。", icon: "⌂", mapQuery: "重庆渝北广场地铁站" },
      { time: "16:00", title: "山城步道 · 从上往下走", note: "老城墙、石阶、江景和旧街巷都在这条路上。全程约 2km，从上往下走会轻松很多。", icon: "↘", mapQuery: "重庆七星岗地铁站1号口", guide: {
        duration: "约 1.5 小时",
        overview: "这可不是一个拍完照就离开的打卡点，而是一段真正长在山坡上的老重庆。右边常能看见江景，老城墙、仁爱堂遗址、荒野花园和小店会一路慢慢出现，一起走走看吧！",
        route: [
          "坐轨道到七星岗站，从 1 号口出；步行导航先设为“渝中区佳实养老院”。",
          "出站后右转直走，过两处斑马线，再上楼梯到通远门；穿过城门后右转，沿老城墙前行。",
          "走到壁画一带靠左下坡，很快进入山城巷；认准沿途“山城步道”与“山城巷”指示牌。",
          "依次经过老街、仁爱堂与荒野花园一带，整体保持从上往下，不要反向爬坡。",
          "走出山城步道下半城出口后右转，经过地下通道，沿十八梯指示继续走。",
        ],
      } },
      { time: "17:30", title: "十八梯", note: "从山城步道自然接到十八梯，旧街、吊脚楼和新街区就在脚步间慢慢交错。", icon: "↗", mapQuery: "重庆十八梯传统风貌区", guide: {
        duration: "约 40—50 分钟",
        overview: "十八梯曾经连接着重庆的上半城与下半城。保留下来的石梯、老巷和传统建筑都很有山城味道，傍晚灯光亮起来以后，又会变成完全不同的景色。",
        route: ["从山城步道下半城出口出来，按“十八梯”路牌步行约 500 米。", "进入街区后保持向较场口一侧缓慢上行，沿主街穿过老巷和观景平台。", "最后从靠近较场口的北侧出口离开，接着步行去解放碑。"],
      } },
      { time: "18:20", title: "解放碑", note: "走进最热闹的上半城！先补水休息，再一起决定今晚吃什么。", icon: "◇", mapQuery: "重庆解放碑步行街", guide: {
        duration: "约 25—35 分钟",
        overview: "这里是重庆最有代表性的城市中心之一。我们在纪念碑前留下四个人的合照，再去八一路补充一点能量；不用急着逛商场，把时间留给后面的夜景吧。",
        route: ["从十八梯北侧出口往较场口、解放碑方向走，跟着步行导航即可。", "到纪念碑合照后，可在八一路一带补水或买小吃。", "之后向临江门方向步行前往魁星楼。"],
      } },
      { time: "18:55", title: "魁星楼", note: "明明只上了两层，桥下却有二十多层高——这就是立体重庆吗！", icon: "▦", mapQuery: "重庆医科大学附属第二医院外科楼西南门", guide: {
        duration: "约 20—30 分钟",
        overview: "魁星楼最有趣的是广场、天桥和山城高差共同制造的错觉。从街面看只是普通的二层平台，走到桥边再往下看，竟然已经是二十多层的高度了。",
        route: ["导航不要只搜“魁星楼”，容易被带到楼下。直接定位“重庆医科大学附属第二医院（外科楼西南门）”。", "到达后面对医院大楼，沿左手边楼梯上去，走一小段就是魁星楼广场和天桥。", "拍完后从临江门一侧离开，附近解决晚饭，再往洪崖洞走。"],
      } },
      { time: "20:20", title: "洪崖洞 · 千厮门夜景", note: "灯火亮起来了！从洪崖洞一路看到千厮门，把第一晚的夜景好好收进回忆里。", icon: "✦", mapQuery: "重庆洪崖洞11楼入口", guide: {
        duration: "约 60 分钟",
        overview: "洪崖洞像是贴着嘉陵江崖壁生长起来的吊脚楼。最值得期待的，是从高层街面一路走到滨江路时不断变化的高度，还有隔着江水看到的整片灯火。",
        route: ["晚饭后从魁星楼沿临江路向戴家巷、洪崖洞方向步行。", "先从洪崖洞 11 楼街面入口进入，感受“顶层仍是马路”的重庆高差。", "根据现场人流选择楼梯或电梯下到 1 楼滨江路，抬头看吊脚楼全景。", "最后沿滨江路或安全步行通道去千厮门附近看桥与洪崖洞同框，再返程。"],
      } },
      { time: "夜间", title: "回民宿", note: "第一天辛苦啦。早点休息，明天可是最重要的 Aqours Only！", icon: "☾", mapQuery: "重庆渝北广场地铁站", mascot: "/images/chika/sleepy.jpg", lyric: {
        japanese: "だからこの時を楽しくしたい",
        chinese: "所以，想让此刻尽情快乐。",
        song: "WATER BLUE NEW WORLD",
      } },
    ]},
    { id: 2, date: "2026-08-23", dateLabel: "08.23", weekday: "周日", theme: "Aqours Only 日", subtitle: "今天的闪闪发光，就全部交给 Aqours！", accent: "#087dcc", lyric: {
      japanese: "最高の今日にしよう！",
      chinese: "让今天成为最棒的一天吧！",
      song: "MY舞☆TONIGHT",
    }, stops: [
      { time: "上午", title: "自然醒 · 早午饭", note: "今天不赶景点。舒舒服服睡醒，再一起吃顿饱饱的早午饭。", icon: "☀" },
      { time: "10:00", title: "出门前最终检查", note: "手机、充电宝、痛包、吧唧、谷子和水——全部准备完成！", icon: "✓", tag: "出门前" },
      { time: "10:30", title: "从渝北广场出发", note: "10号线 → 中央公园西 → 重庆大悦城。", icon: "M", mapQuery: "重庆大悦城", guide: {
        duration: "预留约 30 分钟",
        overview: "今天不绕去其他地方，把期待和体力全部留给 Aqours Only！中央公园西出站后，跟着大悦城与会场指示一路前进。",
        route: ["渝北广场站进入 10 号线，乘车到中央公园西。", "出站后跟随重庆大悦城导向，进入商场后再找 MODERN SKY LAB。", "11:00 左右到场，给找入口、排队和见同好留足时间。"],
      } },
      { time: "11:00", title: "到达会场", note: "MODERN SKY LAB 重庆，我们来啦！留足时间找入口、排队，也别忘了和同好见面。", icon: "◎", mapQuery: "重庆大悦城 MODERN SKY LAB" },
      { time: "12:00", endTime: "20:00", title: "Aqours Only", note: "四个人一起，把今天变成最闪耀的回忆吧！", icon: "★", tag: "主活动", mascot: "/images/chika/good-friends.jpg", lyric: {
        japanese: "船が往くよ　ミライへ旅立とう",
        chinese: "出发吧，驶向属于我们的未来。",
        song: "MIRAI TICKET",
      } },
      { time: "20:20", title: "四人火锅 / 聚餐", note: "活动结束，当然要开庆功宴！吃什么、去哪里，就交给现场的我们决定。", icon: "♨" },
      { time: "夜间", title: "回民宿", note: "谷子都带好了吗？回民宿一起整理照片，也把今天的快乐再聊一遍吧。", icon: "☾", mapQuery: "重庆渝北广场地铁站" },
    ]},
    { id: 3, date: "2026-08-24", dateLabel: "08.24", weekday: "周一", theme: "山城漫步", subtitle: "最后一天，也要一直闪耀到夜色里！", accent: "#00a968", stops: [
      { time: "上午", title: "长江索道 · 北站上车", note: "从渝中区飞过长江！到达南岸后，正好一路接上龙门浩与下浩里。", icon: "↔", mapQuery: "重庆长江索道北站新华路", guide: {
        duration: "乘坐很短，排队时间浮动",
        overview: "长江索道原本就是重庆人的跨江交通工具。车厢升起来以后，江面、东水门大桥和两岸层层叠叠的建筑都会出现在眼前。选择“北站 → 南站”，下车就能顺路走进南岸老街。",
        route: ["从民宿坐地铁前往小什字一带，步行导航到“长江索道北站（新华路）”。", "按预约或现场安排进站，四个人尽量站在同一侧，不必为抢窗位拥挤。", "抵达南站后出站，按龙门浩老街方向步行约几百米。"],
      } },
      { time: "11:00", title: "龙门浩老街", note: "从高处慢慢走向江边，层叠屋檐、老门洞和对岸的渝中半岛都在等我们。", icon: "⌂", mapQuery: "重庆龙门浩老街揽月台", guide: {
        duration: "约 60 分钟",
        overview: "龙门浩依山临江，老建筑、石阶和门洞与重新修复的空间叠在一起。揽月台、观江平台，还有正好框住东水门大桥的门洞，都很适合留下四个人的合照。",
        route: ["从索道南站出来后往上新街、龙门浩方向走，先到老街较高处。", "从高处沿主游线逐层向下，经过观江平台、门洞与里外巷子。", "不要走回头路，在靠下浩里、望耳巷一侧离开，继续去下一站。"],
      } },
      { time: "12:30", title: "下浩里", note: "午饭、避暑、慢慢逛店。最热的时候不用逞强，休息也是旅行的一部分！", icon: "☂", mapQuery: "重庆下浩里", guide: {
        duration: "约 1—1.5 小时",
        overview: "下浩里更像一段仍有生活气息的坡巷，旧房、黄墙、石阶和小店自然地混在一起。这里不用追着打卡，找到想吃的午饭、喝点冰冰的饮料，舒服地度过最热的下午吧。",
        route: ["从龙门浩靠望耳巷一侧向下浩里衔接，沿现场导视走，不要直接沿大坡反复爬升。", "遇到连接高差的公共电梯可直接使用，出来后继续按“下浩里”与标志墙方向走。", "逛到合适的餐厅就先吃饭休息；结束后从上新街一带坐地铁离开。"],
      } },
      { time: "傍晚", title: "地铁到鹅岭站 1 号口", note: "太阳没那么晒了，向今晚的下坡 City Walk 出发！", icon: "M", mapQuery: "重庆鹅岭地铁站1号口" },
      { time: "17:30", title: "鹅岭公园", note: "在山脊上的老公园慢慢散步，等天空换上傍晚的颜色。", icon: "♧", mapQuery: "重庆鹅岭公园正门", guide: {
        duration: "约 40—50 分钟",
        overview: "鹅岭公园比热闹的街区安静许多，老树、池塘和石桥都藏在山脊上的风景里。我们不用走遍每条路，只要找到一处喜欢的开阔位置，看着渝中半岛一点点亮起来。",
        route: ["鹅岭站 1 号口出，沿楼梯上行后右转，过马路再右转，按公园指示步行约 5—8 分钟。", "入园后选择主路慢走，经过莲池、石桥一带；体力合适再去视野更高的位置。", "从公园正门出来后过马路左转，沿道路去鹅岭二厂。"],
      } },
      { time: "18:20", title: "鹅岭二厂 · 顺路节点", note: "旧印制厂、天台和城市街景，简单逛一圈、拍几张照片就继续前进。", icon: "▦", mapQuery: "重庆鹅岭二厂文创公园", lyric: {
        japanese: "こんな遠いところまで",
        chinese: "不知不觉，已经来到了这么远的地方。",
        song: "キセキヒカル",
      }, guide: {
        duration: "约 20—30 分钟",
        overview: "旧工业建筑、楼梯平台和涂鸦拼成了二厂独有的城市片段。今晚它只是鹅岭公园与李子坝之间的一站，拍几张喜欢的照片、补充一点能量，我们就继续向夜色出发。",
        route: ["从鹅岭公园正门出来，过马路后左转，经过学校一带继续直走。", "看到 TESTBED2 或二厂导视后进入街区，顺着主路与平台短暂逛一圈。", "回到二厂广场一侧，寻找通往下坡道路的出口，准备 19:00 出发。"],
      } },
      { time: "19:00", title: "下坡 City Walk", note: "离开二厂，走进坡路、旧街和窄巷。从黄昏开始，一路走进重庆的夜色吧！", icon: "↘", tag: "黄昏出发", lyric: {
        japanese: "どこへ行っても忘れないよ",
        chinese: "无论走到哪里，都不会忘记。",
        song: "Brightest Melody",
      }, guide: {
        duration: "约 60—75 分钟",
        overview: "这一段不用追求最短路线。坡道的转弯、居民楼、旧墙，还有一盏盏亮起来的灯，都会成为旅行的最后一幕。只要记住大方向始终朝李子坝下行，就慢慢享受这段路吧。",
        route: ["从二厂广场一侧向下坡出口走；遇岔路先确认导航仍指向李子坝，不要反向爬坡。", "沿下坡道路经过旧街与涂鸦墙一带，看到适合的窄巷和黄昏灯光就停下来拍照。", "下到主路后右转，再按李子坝观景平台方向走；接近轨道站时注意人车分流。"],
      } },
      { time: "20:15", title: "李子坝", note: "轨道穿过楼宇，山城已经亮起灯火。我们在这里为三日旅行画上句号。", icon: "✦", mapQuery: "重庆李子坝轻轨穿楼观景平台", guide: {
        duration: "约 20—30 分钟",
        overview: "李子坝把重庆交通与建筑共存的样子直接摆在眼前。站在观景平台等一班 2 号线穿楼而过，也别忘了看看附近的小黄楼和层层道路组成的夜景。",
        route: ["先到李子坝轨道穿楼观景平台，在安全区域等一两班列车。", "拍完后步行进入李子坝站，按当晚取行李路线换乘回渝北广场。", "离开前四个人确认手机、相机、随身包和购买的谷子都在。"],
      } },
      { time: "之后", title: "回民宿取行李 · 各自返程", note: "三天的故事先写到这里。返程时间待确认，出发前再一起核对。", icon: "⌁", tag: "待确认", mapQuery: "重庆渝北广场地铁站", lyric: {
        japanese: "でも笑顔でね　また会おう",
        chinese: "那就笑着说，下次再见吧。",
        song: "Brightest Melody",
      } },
    ]},
  ] satisfies TripDay[],
} as const;
